import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

import ValidateInput from '../../components/ValidateInput'
import { BASE_URL } from '../../env';

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

const UpdateSubscriptionPlan = () => {
    const [planName, setPlanName] = useState("");
    const [duration, setDuration] = useState("");
    const [price, setPrice] = useState("");
    const [token, setToken] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState(null);

    let history = useHistory();
    let { id } = useParams();

    useEffect(() => {
        let isLocal = localStorage.getItem('isLoggedIn');
        let isSession = sessionStorage.getItem('isLoggedIn');
        if(isLocal){
            setToken(localStorage.getItem('token'));
        }else if(isSession){
            setToken(sessionStorage.getItem('token'));
        }
    }, [])

    useEffect(() => {
        if(token !== null){
            const params = {
                id: id
            }
    
            // converting (json --> form-urlencoded)
            const data = Object.keys(params)
            .map((key) => `${key}=${encodeURIComponent(params[key])}`)
            .join('&');
    
            axios
            .post(BASE_URL+"/admin/get-subscription-plan", data,{
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'authorization': token
                    }
                })
            .then((res) => {
                // Validating form
                if(res.data.status === 'success'){
                    console.log(res.data);
                    setPrice(res.data.result.price);
                    setDuration(res.data.result.duration);
                    setPlanName(res.data.result.plan_name);
                }else if(res.data.status === "error"){
                    Toast.fire({
                        icon: 'error',
                        title: res.data.message
                    })
                }else{
                    Toast.fire({
                        icon: 'error',
                        title: "Cannot process request"
                    })
                }
            })
            .catch((err) => {
                console.log(err);
            });
        }
        // eslint-disable-next-line
    }, [token])

    function handleSubmit(event){
        setIsLoading(true);
        event.preventDefault();

        const params = {
            id: id,
            plan_name: planName,
            price: price,
            duration: duration
        }

        // converting (json --> form-urlencoded)
        const data = Object.keys(params)
        .map((key) => `${key}=${encodeURIComponent(params[key])}`)
        .join('&');

        axios
        .post(BASE_URL+"/admin/update-subscription-plan", data,{
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'authorization': token
                }
            })
        .then((res) => {
            // Validating form
            setIsLoading(false);
            if(res.data.status === 'success'){
                console.log(res.data);
                Toast.fire({
                    icon: 'success',
                    title: "Plan updated successfully"
                })
                history.push("/subscription-plan");
            }else if(res.data.status === "validation_error"){
                setErrors(res.data.errors);
                console.log(errors);
            }else if(res.data.status === "error"){
                Toast.fire({
                    icon: 'error',
                    title: res.data.message
                })
                setErrors(null);
            }else{
                Toast.fire({
                    icon: 'error',
                    title: "Cannot process request"
                })
                setErrors(null);
            }
        })
        .catch((err) => {
            setIsLoading(false);
            if(err.response.status === 401){
                Toast.fire({
                    icon: 'error',
                    title: "Unauthorized Access"
                })
            }
            console.log(err);
        });
    }

    return(
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <h3>Update Subscription Plan</h3>
                    </div>
                    <form onSubmit={handleSubmit} className="row justify-content-center">
                        <div className="card-body col-8">
                            <ValidateInput 
                                title="Subscription Plan Name"
                                id="subscriptionPlanName"
                                value={planName}
                                type="text"
                                errors={errors}
                                searchFor="plan_name"
                                setValue={setPlanName}
                            />
                            <ValidateInput 
                                title="Plan Price (in INR)"
                                id="planPrice"
                                value={price}
                                type="number"
                                errors={errors}
                                searchFor="price"
                                setValue={setPrice}
                            />
                            <ValidateInput 
                                title="Plan Duration (in Days)"
                                id="planDuration"
                                value={duration}
                                type="number"
                                errors={errors}
                                searchFor="duration"
                                setValue={setDuration}
                            />
                            {!isLoading && <button className="btn btn-primary mt-3">UPDATE CHANGES</button>}
                            {isLoading && <button className="btn btn-primary mt-3" disabled><i className="fas fa-spinner fa-spin mr-1"></i> UPDATING CHANGES...</button>}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default UpdateSubscriptionPlan;